import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({ GridFlag, BooleanFlagFilterCell }) => {
  const dataColumns = [
    {
      field: 'SRFProfileId',
      title: 'SRFProfileId',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'SRFProfilesName',
      title: 'Profile Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'SRFProfilesDetails',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'AppURL',
      title: 'App URL',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'SRFProfilesSetupName',
      title: 'Setup Name',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'active',
      title: 'Active',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'MTFTermId',
      title: 'Term Id',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFDevcod',
      title: 'MTFDevcod',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'WHID',
      title: 'Warehouse Id',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'RFVenName',
      title: 'RF Ven Name',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFURL',
      title: 'MTF URL',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFPort',
      title: 'MTF Port',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFProtocol',
      title: 'MTF Protocol',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'MTFTermType',
      title: 'Term Type',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
  ];

  return dataColumns;
};
export default DataColumns;
